module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('BannerUpload', {
    attrs: {
      "MainHeading": "Broadcast live",
      "MainText": "Broadcast from your browser, run pay-per-view, sell exclusives, limit room capacity & allow up to 40 video participants",
      "Icon": _vm.iconImage,
      "MainImage": _vm.bannerImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page live-page mx-5"
  }, [_c('div', {
    staticClass: "page-content mt-4"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pb-0": ""
    }
  }, [_c('h2', {
    staticClass: "heading-2"
  }, [_vm._v("Choose")]), _vm._v(" "), _c('div', {
    staticClass: "plans"
  }, _vm._l((_vm.plans), function(plan, i) {
    return _c('div', {
      key: i,
      staticClass: "plan",
      attrs: {
        "sm3": ""
      }
    }, [_c('div', {
      staticClass: "price-title-flex"
    }, [_c('div', {
      staticClass: "upload-tab-img uploadLive"
    }), _vm._v(" "), (plan.id === 'custom') ? _c('h3', [_vm._v("\n              Custom\n            ")]) : _c('h3', [_vm._v("\n              " + _vm._s(plan.viewersLimit) + " viewers\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "price-highlight mt-4"
    }, [_c('h4', {
      staticClass: "_price"
    }, [_vm._v("$" + _vm._s(plan.price) + " "), _c('span', [_vm._v("/hour")])])]), _vm._v(" "), _c('div', {
      staticClass: "price-highlight-button dflex align-center mt-2"
    }, [_c('v-select', {
      staticClass: "pa-0 hour-selector",
      attrs: {
        "items": _vm.hours,
        "dense": "",
        "item-text": "title",
        "item-value": "value",
        "hide-details": "",
        "outlined": ""
      },
      model: {
        value: (plan.selectedHour),
        callback: function($$v) {
          _vm.$set(plan, "selectedHour", $$v)
        },
        expression: "plan.selectedHour"
      }
    }), _vm._v(" "), _c('v-btn', {
      staticClass: "_button",
      attrs: {
        "outline": ""
      }
    }, [(!_vm.hasFree_stream_seconds) ? _c('span', [_vm._v("Add time")]) : _c('span', [_vm._v("Add time")])])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('h2', {
    staticClass: "heading-3"
  }, [_vm._v("Remaining time")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-container",
    class: !(_vm.hasFree_stream_seconds) ? "empty" : null
  }, [(!(_vm.hasFree_stream_seconds)) ? _c('div', [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Unused time on your events is saved here for later use\n          ")])]) : _c('div', {
    staticClass: "wrapper-info dflex justify-space-between align-center mb-3"
  }, [_c('div', [_c('h3', {
    staticClass: "mr-2"
  }, [_vm._v("Rollover time remainings")]), _vm._v(" "), _c('span', {}, [_vm._v("You have")]), _vm._v(" "), _c('b', {}, [_vm._v(_vm._s(_vm._f("timeInWords")(_vm.currentUser.free_stream_seconds)))]), _vm._v(" "), _c('span', [_vm._v("remaining")])]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "app-blue-2 px-2",
    style: ([
      !_vm.hasFree_stream_seconds ?
      {
        'background-color': '#c9c3c3 !important',
        color: 'grey !important',
      } :
      {} ]),
    attrs: {
      "disabled": !_vm.hasFree_stream_seconds,
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'VideoCreate'
        })
      }
    }
  }, [_c('b', [_vm._v("Use time")])])], 1)])])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "learn-more-dialog"
    },
    model: {
      value: (_vm.learnMoreActive),
      callback: function($$v) {
        _vm.learnMoreActive = $$v
      },
      expression: "learnMoreActive"
    }
  }, [_c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    staticClass: "mr-3",
    attrs: {
      "src": require('@/assets/up_live.svg'),
      "width": "40",
      "alt": "live signal icon"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("\n          Maximize revenue with\n          "), _c('br'), _vm._v("\n          live broadcasts\n        ")])]), _vm._v(" "), _c('hr', {
    staticClass: "light my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-3"
  }, [_vm._v("\n        Use these tools to maximize sale conversions with limited audiences.\n        "), _c('br'), _vm._v("\n        There’s an average 16% sales conversation on products sold on YouSound\n        live broadcasts.\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "_highlight ml-3"
  }, [_c('li', {
    staticClass: "app-bold"
  }, [_vm._v("Sell products (you keep 100%)")]), _vm._v(" "), _c('li', {
    staticClass: "app-bold"
  }, [_vm._v("\n          Sell exclusive “live video only” products (you keep 100%)\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "app-bold"
  }, [_vm._v("\n          Sell pay-per-view access up to $10,000/viewer (you keep 90%)\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "app-bold"
  }, [_vm._v("Limit event capacity")])]), _vm._v(" "), _c('hr', {
    staticClass: "light my-3"
  }), _vm._v(" "), _c('div', [_vm._v("\n        As a creator, you own and operate your brand & cover your costs.\n        "), _c('br'), _vm._v("\n        We do not sell your information & you keep the lion share of profits.\n      ")])]), _vm._v(" "), (_vm.showPaymentModal) ? _c('payment-modal', {
    attrs: {
      "amount": _vm.payable,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.proceedToUpload
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fa5c96b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/live.vue
// module id = 1644
// module chunks = 180